import React from 'react';
import { Pie } from 'react-chartjs-2';

const ClustersPieChart = (clusterCount, issue) => {

    const data = {
        labels: [],
        datasets: [
            {
                label: "Clusters",
                data: [],
                backgroundColor: [],
                borderColor: [],
                borderWidth: 1
            }
        ]
    }

    if (clusterCount !== undefined && clusterCount.clusterCount !== undefined) {
        Object.entries(clusterCount.clusterCount).map(([issue, counts]) => {
            if (issue === "Blades") {
                Object.entries(counts).map(([cluster, count]) => {
                    data.labels.push(cluster)
                    data.datasets[0].data.push(count)
                    var color = '#' + Math.random().toString(16).substr(-6);
                    data.datasets[0].backgroundColor.push(color)
                    data.datasets[0].borderColor.push(color)
                })
            }
        })

        const options = {
            legend: {
                display: false
            },
            options: {
                title: {
                    display: false,
                    text: ''
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem) {
                            return tooltipItem.yLabel;
                        }
                    }
                }
            }
        }

        return (
            <Pie
                width={300}
                height={300}
                data={data}
                options={options}
            />
        )
    } else return (<p>loading</p>)
}

export default ClustersPieChart;